import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { logEvent } from '~/config/firebase.config';
import { trackMetaPixel } from '~/utils/attribution';
import { readSignupLang } from '~/utils/signupLang';

import { AuthShell } from './AuthKit';
import styles from './auth.redesign.module.css';

export default function Success() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    useEffect(() => {
        logEvent('screen_view', 'Success');
        // Restaure la langue choisie à l'inscription : l'aller-retour Stripe
        // recharge la page et la détection (navigateur seul) l'aurait perdue.
        const saved = readSignupLang();
        if (saved && saved !== i18n.language.split('-')[0]) {
            i18n.changeLanguage(saved);
        }

        // Checkout Stripe terminé = l'essai de 14 jours démarre réellement ici.
        // Une seule fois par checkout (la page est rechargeable / dans
        // l'historique), et rien sur une réactivation (?reactivated=true).
        const params = new URLSearchParams(window.location.search);
        const sessionId = params.get('session_id');
        if (params.get('reactivated') || !sessionId) return;
        try {
            const guardKey = `starttrial_sent_${sessionId}`;
            if (localStorage.getItem(guardKey)) return;
            localStorage.setItem(guardKey, '1');
        } catch {
            // localStorage indisponible : on envoie quand même (au pire un doublon)
        }
        // eventID = id de session Checkout = event_id du StartTrial serveur
        // (stripe-b2b metaCapi.js) : Meta déduplique les deux.
        trackMetaPixel('StartTrial', { eventID: sessionId });
    }, []);

    return (
        <AuthShell>
            <div className={styles.success}>
                <span className={styles.emoji}>🥳</span>
                <h1 className={styles.title}>{t('success.title')}</h1>
                <p className={styles.subtitle}>{t('success.description')}</p>
                {/* ?onboarding=1 : déclenche le tutoriel jouable à l'arrivée
                    sur la home (cf gate dans HomeContent). */}
                <button type="button" className={styles.submit} onClick={() => navigate('/home?onboarding=1')}>
                    {t('success.button')}
                </button>
            </div>
        </AuthShell>
    );
}
